import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import './tailwind.css';
import './index.css';
import App from './App';
import ErrorBoundary from './js/Components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import i18n from './services/i18n';

import { store } from './js/Store/configureStore';

const container = document.getElementById('root');
const root = createRoot(container);
// StrictMode disabled in prod to rule out double-invoke effects during
// the React 18 removeChild crash investigation. Re-enable once stable.
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <Router>
          <App />
        </Router>
      </I18nextProvider>
    </Provider>
  </ErrorBoundary>
);

reportWebVitals();
